import { Fragment, useContext } from "react";
import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { StylizedInternalLink } from "../../../../../components/Navigation/Components";
import { RootContext } from "../../../../../stores";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        demo: {
            color: theme.palette.action.active,
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(2)
        },
    })
);

export const DemoRequest = observer(() => {

    /********* React hooks *********/

    const classes = useStyles();
    const rootStore = useContext(RootContext);

    const handleDemoClicked = () => {
        rootStore.navigationStore.appwideDialogStates.contactUsDialog.setOpen(true);
        rootStore.helpStore.setHelpMessageOverrides({
            subject: 'Demo Request',
            message: `Hello,\n\nI would like to schedule a demo of the Voltage Volunteering platform.`
        });
    };

    /********* Render *********/

    return (
        <Fragment>
            <Typography className={classes.demo}>
                Interested in learning more about using Voltage Volunteering for your volunteer program?
            </Typography>
            <StylizedInternalLink onClick={handleDemoClicked}>Request a demo</StylizedInternalLink>
        </Fragment>
    );
});
